import React, { useEffect, useRef } from "react";

const LazyLoadIframe = ({ src, title, width = "560", height = "315" }) => {
    const iframeRef = useRef();

    useEffect(() => {
        const iframeElement = iframeRef.current;

        const lazyLoad = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const iframe = entry.target;
                    iframe.src = src;
                    observer.unobserve(iframe);
                }
            });
        };

        const observer = new IntersectionObserver(lazyLoad);
        if (iframeElement) {
            observer.observe(iframeElement);
        }

        return () => {
            if (iframeElement) {
                observer.unobserve(iframeElement);
            }
        };
    }, [src]);

    return (
        <iframe
            ref={iframeRef}
            data-src={src}
            width={width}
            height={height}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
        />
    );
};

export default LazyLoadIframe;
